import React from 'react'
import {
  UserOutlined,
  UnorderedListOutlined,
  UploadOutlined,
  FundProjectionScreenOutlined,
  ScanOutlined,
  // SettingFilled,
  SettingOutlined,
  BarsOutlined,
  ProfileOutlined,
  FundViewOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  MailOutlined,
  AlignLeftOutlined,
  PrinterOutlined,
  ClearOutlined,
  CopyrightOutlined
} from '@ant-design/icons'
// import Welcome from '@/pages/welcome/Welcome'
import SendList from '@/pages/SendList/SendList'
import PFSendList from '@/pages/SendList/PFSendList'
import UIDDisablementReport from '@/pages/WriteOff/UIDDisablementReport'
import UIDCollection from '@/pages/WriteOff/UIDCollection'
import UIDCollectionUndoRecord from '@/pages/WriteOff/UIDCollectionUndoRecord'
// import SKU from '@/pages/SKU/sku'
import NFCSKUManagermentPage from '@/pages/SKU/nfcSkuManagerment'
import NFCUIDReportPage from '@/pages/SKU/NFCUIDReport'
import ChannelPage from '@/pages/configuration/channel'
import PlantPage from '@/pages/configuration/plant'
import TagTypePage from '@/pages/configuration/tagType'
import RFDevicePage from '@/pages/configuration/RFDevice'
import WriteOffNFCBatchNumber from '@/pages/configuration/writeOffNFCBatchNumber'
// import PFSKU from '@/pages/SKU/pfsku'
import RFID from '@/pages/SKU/rfid'
import TagPage from '@/pages/Tag/tag'
import Dashboard from '@/pages/dashboard/Dashboard'
import APIDashboard from '@/pages/dashboard/APIDashboard'
import SortOutPage from '@/pages/Sort/sortout'
import WavePage from '@/pages/WaveRun/wave'
import PFTagPage from '@/pages/PFTag/pftag'
import UserManagement from '@/pages/UserManagement/UserManagement'
import RoleManagement from '@/pages/RoleManagement/RoleManagement'

import RfidStorePage from '@/pages/rfid/rfidConfig/rfidStore'
import RfidTunnelMachine from '@/pages/rfid/rfidConfig/rfidTunnelMachine'
// import LabelConfigPage from '@/pages/rfid/rfidConfig/labelConfig'
import AdcWarehouse from '@/pages/rfid/rfidConfig/adcWarehouse'
import SpecialTypeConfigPage from '@/pages/rfid/rfidConfig/specialTypeConfig'
import SpecialSkuConfigPage from '@/pages/rfid/rfidConfig/specialSkuConfig'
import NddcStoreConfigPage from '@/pages/rfid/rfidConfig/nddcStore'
import RfidDashboard from '@/pages/rfid/rfidDashboard/rfidDashboard'
import RfidSkuReport from '@/pages/rfid/rfidSku/rfidSkuReport'

import StoreDisplayPage from '@/pages/configuration/storeDisplay'
import ANTTemplate from '@/pages/configuration/antTemplate'
import NFCScanDetailReport from '@/pages/NFCScan/detailReport'
import NFCScanSummaryReport from '@/pages/NFCScan/summaryReport'
import GreyMarketScan from '@/pages/rfid/greyMarket/greyMarketScan'
import GreyMarketReport from '@/pages/rfid/greyMarket/greyMarketReport'

import EmailManagement from '@/pages/email/EmailManagement/EmailManagement'
import NFCUIDSentFailureReport from '@/pages/email/reports/NFCUIDSentFailureReport'
import NFCDailyReport from '@/pages/email/reports/NFCDailyReport'
// import RFIDDailyReport from '@/pages/email/reports/RFIDDailyReport'
import RfidAbnormalReport from '@/pages/email/reports/rfidAbnormalReport'

import RSOOverviewReport from '@/pages/rfid/defectiveReturn/RSOOverviewReport'
import RSODetailReport from '@/pages/rfid/defectiveReturn/RSODetailReport'
import SkipRejectRateReport from '@/pages/rfid/defectiveReturn/skipRejectRateReport'
import RfidTunnelScanAccuracyReport from '@/pages/rfid/reports/rfidTunnelScanAccuracyReport'
import OperationAccuracySummary from '@/pages/rfid/reports/operationAccuracySummary'
import OperationAccuracyDetail from '@/pages/rfid/reports/operationAccuracyDetail'
import NFCSuspiciousUidReport from '../pages/email/reports/NFCSuspiciousUidReport'
import ClcRfidBindReport from '@/pages/rfid/nddc/clcRfidBindReport'
import ClcRfidBindHistoryReport from '@/pages/rfid/nddc/clcRfidBindHistoryReport'
import NddcRfidBindReport from '@/pages/rfid/nddc/nddcRfidBindReport'
import NddcRfidBindHistoryReport from '@/pages/rfid/nddc/nddcRfidBindHistoryReport'
import UnbindByCartonWeb from '@/pages/rfid/nddc/unbindByCartonWeb'
import CodePage from '@/pages/code/code'
import ReprintSCPage from '@/pages/reprint/printWeb'
import ReprintReportPage from '@/pages/reprint/reprintReport'

import OutboundDetailReport from '@/pages/rfid/csc/outboundDetail'
import OutboundSummaryReport from '@/pages/rfid/csc/outboundSummary'
import TunnelScanValidationResult from '../pages/rfid/reports/tunnelScanValidationResult'
import ObTunnelScanValidationResult from '../pages/rfid/reports/obTunnelScanValidationResult'
import SpecialSkuReport from '../pages/rfid/reports/specialSkuReport'
import ObSpecialSkuReport from '../pages/rfid/reports/obSpecialSkuReport'
import RfidReworkSummary from '@/pages/rfid/reports/rfidReworkSummary'
import RfidReworkDetail from '@/pages/rfid/reports/rfidReworkDetail'
import ObClaimReport from '@/pages/rfid/reports/obClaimReport'
import EpcCycleReport from '@/pages/rfid/reports/epcCycleReport'
// 内网访问路由
export const routerConfigIn = [
  {
    key: '/code',
    label: 'Generate QR code',
    labelEn: 'Generate QR code',
    labelZh: '生成二维码',
    hidden: true,
    component: CodePage
  },
  {
    key: '/NFC',
    label: 'NFC',
    labelEn: 'NFC',
    labelZh: 'NFC',
    icon: <BarsOutlined />,
    hidden: false,
    children: [
      {
        key: '/dashboard',
        label: 'Dashboard',
        labelEn: 'Dashboard',
        labelZh: '看板',
        icon: <FundProjectionScreenOutlined />,
        // hidden: true,
        permission: ['menu_nfc_dashboard'],
        component: Dashboard
      },
      {
        key: '/apiDashboard',
        label: 'API Dashboard',
        labelEn: 'API Dashboard',
        labelZh: 'API看板',
        icon: <FundViewOutlined />,
        // hidden: true,
        permission: ['menu_nfc_apiDashboard', 'menu_nfc_apiDashboard_view'],
        component: APIDashboard
      },
      {
        key: '/nfcsku',
        label: 'NFC SKU Update',
        labelEn: 'NFC SKU Update',
        labelZh: 'NFC产品',
        icon: <UploadOutlined />,
        hidden: false,
        children: [
          // {
          //   key: '/nfcsku/fullsku',
          //   label: 'FULL SKU',
          //   labelEn: 'FULL SKU',
          //   labelZh: 'FULL产品',
          //   hidden: false,
          //   permission: ['Admin','NFC Admin'],
          //   component: SKU
          // },
          // {
          //   key: '/nfcsku/nddcsku',
          //   label: 'NDDC SKU',
          //   labelEn: 'NDDC SKU',
          //   labelZh: 'NDDC产品',
          //   hidden: false,
          //   permission: ['Admin','NFC Admin'],
          //   component: PFSKU
          // },
          {
            key: '/nfcsku/rfid',
            label: 'SML RFID SKU',
            labelEn: 'SML RFID SKU',
            labelZh: 'SML RFID产品',
            hidden: false,
            permission: ['menu_nfc_nfcSkuUpdate_rfidSku', 'menu_nfc_nfcSkuUpdate_rfidSku_view'],
            component: RFID
          },
          {
            key: '/nfcsku/management',
            label: 'nfc sku management',
            labelEn: 'NFC SKU Management',
            labelZh: 'NFC SKU管理',
            hidden: false,
            permission: ['menu_nfc_nfcSkuUpdate_nfcSkuManagement', 'menu_nfc_nfcSkuUpdate_nfcSkuManagement_view'],
            component: NFCSKUManagermentPage
          }
        ]
      },
      {
        key: '/nfctag',
        label: 'NFC TAG',
        labelEn: 'NFC TAG',
        labelZh: 'NFC绑定',
        icon: <ScanOutlined />,
        hidden: false,
        children: [
          {
            key: '/nfctag/fulltag',
            label: 'FULL TAG',
            labelEn: 'FULL TAG',
            labelZh: 'FULL绑定',
            hidden: false,
            permission: ['menu_nfc_tag_fullTag'],
            component: TagPage
          },
          {
            key: '/nfctag/nddctag',
            label: 'NDDC TAG',
            labelEn: 'NDDC TAG',
            labelZh: 'NDDC绑定',
            hidden: false,
            permission: ['menu_nfc_tag_nddcTag'],
            component: PFTagPage
          },
          {
            key: '/nfctag/waverun',
            label: 'NDDC Wave Run',
            labelEn: 'NDDC Wave Run',
            labelZh: 'NDDC波次',
            hidden: false,
            permission: ['menu_nfc_tag_nddcWaveRun'],
            component: WavePage
          },
          {
            key: '/nfctag/nddcsort',
            label: 'NDDC Item Sort',
            labelEn: 'NDDC Item Sort',
            labelZh: 'NDDC分拣',
            hidden: false,
            permission: ['menu_nfc_tag_nddcItemSort'],
            component: SortOutPage
          }
        ]
      },
      {
        key: '/writeOff',
        label: 'Write Off',
        labelEn: 'Write Off',
        labelZh: '销毁',
        icon: <ClearOutlined />,
        hidden: false,
        children: [
          {
            key: '/writeOff/writeOffUIDCollection',
            label: 'UID Collection',
            labelEn: 'UID Collection',
            labelZh: 'NFC 销毁UID采集',
            hidden: false,
            permission: ['menu_nfc_configuration_writeOffUIDCollection'],
            component: UIDCollection
          },
          {
            key: '/writeOff/writeOffUIDDisablementReport',
            label: 'UID Disablement Report',
            labelEn: 'UID Disablement Report',
            labelZh: 'NFC 销毁UID报告',
            hidden: false,
            permission: [
              'menu_nfc_configuration_writeOffUIDDisablementReport_view',
              'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_disable',
              'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_scanComplete',
              'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_backToScanning',
              'menu_nfc_configuration_writeOffUIDDisablementReport_view_button_upload&submit'
            ],
            component: UIDDisablementReport
          },
          {
            key: '/writeOff/writeOffUIDCollectionUndoRecord',
            label: 'UID Collection Undo Record',
            labelEn: 'UID Collection Undo Record',
            labelZh: 'UID采集撤回记录',
            hidden: false,
            permission: ['menu_nfc_configuration_write_off_undo_record'],
            component: UIDCollectionUndoRecord
          },
          {
            key: '/configuration/writeOffNFCBatchNumber',
            label: 'Batch Number Configuration',
            labelEn: 'Batch Number Configuration',
            labelZh: 'NFC 销毁批次号配置',
            hidden: false,
            permission: [
              'menu_nfc_configuration_writeOffNFCBatchNumber',
              'menu_nfc_configuration_writeOffNFCBatchNumber_view'
            ],
            component: WriteOffNFCBatchNumber
          }
        ]
      },
      {
        key: '/report',
        label: 'Report',
        labelEn: 'Report',
        labelZh: '报表',
        icon: <UnorderedListOutlined />,
        hidden: false,
        children: [
          {
            key: '/report/query',
            label: 'CLC FULL TAG Report',
            labelEn: 'CLC FULL TAG Report',
            labelZh: 'CLC FULL绑定报表',
            hidden: false,
            permission: ['menu_nfc_report_fullTagReport', 'menu_nfc_report_fullTagReport_view'],
            component: SendList
          },
          {
            key: '/report/nddcquery',
            label: 'CLC NDDC TAG Report',
            labelEn: 'CLC NDDC TAG Report',
            labelZh: 'CLC NDDC绑定报表',
            hidden: false,
            permission: ['menu_nfc_report_nddcTagReport', 'menu_nfc_report_nddcTagReport_view'],
            component: PFSendList
          },
          {
            key: '/report/nfcUIDReport',
            label: 'NFC UID Report',
            labelEn: 'NFC UID Report',
            labelZh: 'NFC UID报表',
            hidden: false,
            permission: [
              'menu_nfc_report_nfcUidReport',
              'menu_nfc_report_nfcUidReport_view',
              // 'menu_nfc_report_nfcUidReport_view_button_unbind',
              'menu_nfc_report_nfcUidReport_view_button_disable'
            ],
            component: NFCUIDReportPage
          },
          {
            key: '/report/nfcUIDSentFailureReport',
            label: 'NFC UID Sent Failure Report',
            labelEn: 'NFC UID Sent Failure Report',
            labelZh: 'NFC UID发送失败报告',
            hidden: false,
            permission: ['menu_email_nfc_uid_send_failure_report', 'menu_email_nfc_uid_send_failure_report_view'],
            component: NFCUIDSentFailureReport
          },
          {
            key: '/report/nfcSuspiciousUidReport',
            label: 'NFC Suspicious UID Report',
            labelEn: 'NFC Suspicious UID Report',
            labelZh: 'NFC UID异常报告',
            hidden: false,
            permission: ['menu_nfc_report_suspiciousReport'],
            component: NFCSuspiciousUidReport
          },
          {
            key: '/report/nfcScanDetailReport',
            label: 'NFC Scan Detail Report',
            labelEn: 'NFC Scan Detail Report',
            labelZh: '扫码详细报告',
            hidden: false,
            permission: ['menu_nfc_report_antScanSummaryReport'],
            component: NFCScanDetailReport
          },
          {
            key: '/report/nfcScanSummaryReport',
            label: 'NFC Scan Summary Report',
            labelEn: 'NFC Scan Summary Report',
            labelZh: '扫码总览报告',
            hidden: false,
            permission: ['menu_nfc_report_antScanDetailReport'],
            component: NFCScanSummaryReport
          },
          {
            key: '/email/nfcDailyReport',
            label: 'NFC Daily Report',
            labelEn: 'NFC Daily Report',
            labelZh: 'NFC日报',
            hidden: false,
            permission: ['menu_email_nfc_daily_report'],
            component: NFCDailyReport
          }
        ]
      },
      {
        key: '/configuration',
        label: 'configuration',
        labelEn: 'Configuration',
        labelZh: '配置',
        icon: <SettingOutlined />,
        hidden: false,
        children: [
          {
            key: '/configuration/channel',
            label: 'Channel',
            labelEn: 'Channel',
            labelZh: '渠道',
            hidden: false,
            permission: ['menu_nfc_configuration_channel', 'menu_nfc_configuration_channel_view'],
            component: ChannelPage
          },
          {
            key: '/configuration/plant',
            label: 'Plant',
            labelEn: 'Plant',
            labelZh: '仓库',
            hidden: false,
            permission: ['menu_nfc_configuration_plant', 'menu_nfc_configuration_plant_view'],
            component: PlantPage
          },
          {
            key: '/configuration/tagType',
            label: 'Tag Type',
            labelEn: 'Tag Type',
            labelZh: 'NFC环扣类型',
            hidden: false,
            permission: ['menu_nfc_configuration_tagType', 'menu_nfc_configuration_tagType_view'],
            component: TagTypePage
          },
          {
            key: '/configuration/storeDisplay',
            label: 'Store Display',
            labelEn: 'Store Display',
            labelZh: '门店展示',
            hidden: false,
            permission: ['menu_nfc_configuration_storeDisplay', 'menu_nfc_configuration_storeDisplay_view'],
            component: StoreDisplayPage
          },
          {
            key: '/configuration/antTemplate',
            label: 'ANT Template',
            labelEn: 'ANT Template',
            labelZh: '蚂蚁模板',
            hidden: false,
            permission: ['menu_nfc_configuration_antTemplate', 'menu_nfc_configuration_antTemplate_view'],
            component: ANTTemplate
          },
          {
            key: '/configuration/RFDevice',
            label: 'RF Device',
            labelEn: 'RF Device',
            labelZh: '扫码枪',
            hidden: false,
            permission: ['menu_nfc_configuration_RFDevice', 'menu_nfc_configuration_RFDevice_view'],
            component: RFDevicePage
          }
        ]
      }
    ]
  },
  {
    key: '/RFID',
    label: 'RFID',
    labelEn: 'RFID',
    labelZh: 'RFID',
    icon: <ProfileOutlined />,
    hidden: false,
    children: [
      {
        key: '/rfiddashboard',
        label: 'Dashboard',
        labelEn: 'Dashboard',
        labelZh: '看板',
        icon: <FundProjectionScreenOutlined />,
        // hidden: true,
        permission: ['menu_rfid_dashboard'],
        component: RfidDashboard
      },
      {
        key: '/rfidNSP',
        label: 'NSP',
        labelEn: 'NSP',
        labelZh: 'NSP',
        icon: <UnorderedListOutlined />,
        hidden: false,
        children: [
          {
            key: '/wsDefectiveReturn',
            label: 'WS Defective Return',
            labelEn: 'WS Defective Return',
            labelZh: 'WS Defective Return',
            hidden: false,
            children: [
              {
                key: '/rfidReport/rsoOverviewReport',
                label: 'RSO Overview Report',
                labelEn: 'RSO Overview Report',
                labelZh: 'RSO 总览报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_rsoOverviewReport'],
                component: RSOOverviewReport
              },
              {
                key: '/rfidReport/rsoDetailReport',
                label: 'RSO Detail Report',
                labelEn: 'RSO Detail Report',
                labelZh: 'RSO 明细报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_rsoDetailReport'],
                component: RSODetailReport
              },
              {
                key: '/skiprejectratereport',
                label: 'Skip & Reject Rate Report',
                labelEn: 'Skip & Reject Rate Report',
                labelZh: '跳过率/拒收率报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_skipRejectRateReport'],
                component: SkipRejectRateReport
              }
            ]
          }
        ]
      },
      {
        key: '/nddc',
        label: 'NDDC',
        labelEn: 'NDDC',
        labelZh: 'NDDC',
        icon: <AlignLeftOutlined />,
        hidden: false,
        children: [
          {
            key: '/nddc/unbindbycartonweb',
            label: 'RFID Unbinding by Carton',
            labelEn: 'RFID Unbinding by Carton',
            labelZh: 'RFID按箱解绑',
            hidden: false,
            permission: ['menu_rfid_clcNddcUnbinding'],
            component: UnbindByCartonWeb
          },
          {
            key: '/nddc/clcbindreport',
            label: 'CLC NDDC RFID Bind Report',
            labelEn: 'CLC NDDC RFID Bind Report',
            labelZh: 'CLC NDDC RFID 绑定报表',
            hidden: false,
            permission: ['menu_rfid_clcNddcRfidBindReport'],
            component: ClcRfidBindReport
          },
          {
            key: '/nddc/clcbindhistoryreport',
            label: 'CLC NDDC RFID Bind History Report',
            labelEn: 'CLC NDDC RFID Bind History Report',
            labelZh: 'CLC NDDC RFID 绑定历史报表',
            hidden: false,
            permission: ['menu_rfid_clcNddcRfidBindHistoryReport'],
            component: ClcRfidBindHistoryReport
          },
          {
            key: '/nddc/nddcbindreport',
            label: 'NDDC RFID Bind Report',
            labelEn: 'NDDC RFID Bind Report',
            labelZh: 'NDDC RFID 绑定报表',
            hidden: false,
            permission: ['menu_rfid_nddcRfidBindReport'],
            component: NddcRfidBindReport
          },
          {
            key: '/nddc/nddcbindhistoryreport',
            label: 'NDDC RFID Bind History Report',
            labelEn: 'NDDC RFID Bind History Report',
            labelZh: 'NDDC RFID 绑定历史报表',
            hidden: false,
            permission: ['menu_rfid_nddcRfidBindHistoryReport'],
            component: NddcRfidBindHistoryReport
          }
        ]
      },
      {
        key: '/rfidReport',
        label: 'Report',
        labelEn: 'Report',
        labelZh: '报表',
        icon: <UnorderedListOutlined />,
        hidden: false,
        children: [
          {
            key: '/rfidReport/rfidskureport',
            label: 'RFID Detail Report',
            labelEn: 'RFID Detail Report',
            labelZh: 'RFID明细报表',
            hidden: false,
            permission: ['menu_rfid_nspRfidReport'],
            component: RfidSkuReport
          },
          // {
          //   key: '/rfidReport/rfidDailyReport',
          //   label: 'RFID Daily Report',
          //   labelEn: 'RFID Daily Report',
          //   labelZh: 'RFID日报',
          //   hidden: false,
          //   permission: ['menu_email_rfid_daily_report'],
          //   component: RFIDDailyReport
          // },
          {
            key: '/rfidReport/rfidTunnelScanAccuracyReport',
            label: 'Tunnel Scan Accuracy',
            labelEn: 'Tunnel Scan Accuracy',
            labelZh: '通道机扫描准确度',
            hidden: false,
            permission: ['menu_rfid_tunnelScanAccuracy'],
            component: RfidTunnelScanAccuracyReport
          },
          {
            key: '/rfidReport/rfidReworkSummary',
            label: 'RFID Rework Summary',
            labelEn: 'RFID Rework Summary',
            labelZh: 'RFID复检总览',
            hidden: false,
            permission: ['menu_rfid_reworkSummary'],
            component: RfidReworkSummary
          },
          {
            key: '/rfidReport/rfidReworkDetail',
            label: 'RFID Rework Detail',
            labelEn: 'RFID Rework Detail',
            labelZh: 'RFID复检明细',
            hidden: false,
            permission: ['menu_rfid_reworkDetail'],
            component: RfidReworkDetail
          },
          {
            key: '/rfidReport/operationAccuracySummary',
            label: 'Operation Accuracy Summary',
            labelEn: 'Operation Accuracy Summary',
            labelZh: '运营准确度总览',
            hidden: false,
            permission: ['menu_rfid_operationAccuracySummary'],
            component: OperationAccuracySummary
          },
          {
            key: '/rfidReport/operationAccuracyDetail',
            label: 'Operation Accuracy Detail',
            labelEn: 'Operation Accuracy Detail',
            labelZh: '运营准确度明细',
            hidden: false,
            permission: ['menu_rfid_operationAccuracyDetail'],
            component: OperationAccuracyDetail
          },
          {
            key: '/rfidReport/rfidAbnormalReport',
            label: 'Tunnel Abnormal Report',
            labelEn: 'Tunnel Abnormal Report',
            labelZh: '通道机异常报表',
            hidden: false,
            permission: ['menu_email_rfid_daily_report'],
            component: RfidAbnormalReport
          },
          {
            key: '/rfidReport/tunnelScanValidationResult',
            label: 'IB - Carton Validation Result Report',
            labelEn: 'IB - Carton Validation Result Report',
            labelZh: '入库 - 最新对比结果',
            hidden: false,
            permission: ['menu_rfid_tunnelScanValidationResult'],
            component: TunnelScanValidationResult
          },
          {
            key: '/rfidReport/specialSkuReport',
            label: 'IB - Special SKU Report',
            labelEn: 'IB - Special SKU Report',
            labelZh: '入库 - 特殊产品报表',
            hidden: false,
            permission: ['menu_rfid_configuration_specialSkuReport'],
            component: SpecialSkuReport
          },
          {
            key: '/rfidReport/obTunnelScanValidationResult',
            label: 'OB - Carton Validation Result Report',
            labelEn: 'OB - Carton Validation Result Report',
            labelZh: '出库 - 最新对比结果',
            hidden: false,
            permission: ['menu_rfid_obTunnelScanValidationResult'],
            component: ObTunnelScanValidationResult
          },
          {
            key: '/rfidReport/obSpecialSkuReport',
            label: 'OB - Special SKU Report',
            labelEn: 'OB - Special SKU Report',
            labelZh: '出库 - 特殊产品报表',
            hidden: false,
            permission: ['menu_rfid_configuration_obSpecialSkuReport'],
            component: ObSpecialSkuReport
          },
          {
            key: '/rfidReport/obClaimReport',
            label: 'RFID OB Claim Report',
            labelEn: 'RFID OB Claim Report',
            labelZh: '出库异常索赔报表',
            hidden: false,
            permission: ['menu_rfid_ob_claim_report'],
            component: ObClaimReport
          },
          {
            key: '/rfidReport/epcCycleReport',
            label: 'RFID EPC Cycle Report',
            labelEn: 'RFID EPC Cycle Report',
            labelZh: 'RFID EPC 流转报表',
            hidden: false,
            permission: ['menu_rfid_epc_cycle_report'],
            component: EpcCycleReport
          }
        ]
      },
      {
        key: '/reprintweb',
        label: 'RFID RePrint',
        labelEn: 'RFID RePrint',
        labelZh: 'RFID补打标签',
        icon: <PrinterOutlined />,
        hidden: false,
        children: [
          {
            key: '/reprintweb/reprint',
            label: 'RFID RePrint',
            labelEn: 'RFID RePrint',
            labelZh: 'RFID补打标签',
            hidden: false,
            permission: ['menu_rfid_reprint'],
            component: ReprintSCPage
          },
          {
            key: '/reprintweb/report',
            label: 'RFID RePrint Report',
            labelEn: 'RFID RePrint Report',
            labelZh: 'RFID补打标签报告',
            hidden: false,
            permission: ['menu_rfid_reprint_report'],
            component: ReprintReportPage
          }
        ]
      },
      {
        key: '/csc',
        label: 'CSC',
        labelEn: 'CSC',
        labelZh: 'CSC',
        icon: <CopyrightOutlined />,
        hidden: false,
        children: [
          {
            key: '/csc/outboundsummary',
            label: 'CSC RFID Outbound Summary',
            labelEn: 'CSC RFID Outbound Summary',
            labelZh: 'CSC RFID 出库总览',
            hidden: false,
            permission: ['menu_rfid_csc_outboundsummary'],
            component: OutboundSummaryReport
          },
          {
            key: '/csc/outbounddetail',
            label: 'CSC RFID Outbound Detail',
            labelEn: 'CSC RFID Outbound Detail',
            labelZh: 'CSC RFID 出库明细',
            hidden: false,
            permission: ['menu_rfid_csc_outbounddetail'],
            component: OutboundDetailReport
          }
        ]
      },
      {
        key: '/rfidconfiguration',
        label: 'rfidconfiguration',
        labelEn: 'Configuration',
        labelZh: '配置',
        icon: <SettingOutlined />,
        hidden: false,
        children: [
          // {
          //   key: '/rfidconfiguration/label',
          //   label: 'Full Label',
          //   labelEn: 'Full Label',
          //   labelZh: '标签',
          //   hidden: false,
          //   permission: ['**'],
          //   component: LabelConfigPage
          // },
          {
            key: '/rfidconfiguration/store',
            label: 'Store',
            labelEn: 'Store',
            labelZh: '门店',
            hidden: false,
            permission: ['menu_rfid_configuration_store', 'menu_rfid_configuration_store_view'],
            component: RfidStorePage
          },
          {
            key: '/rfidconfiguration/tunnelmachine',
            label: 'Tunnel Machine',
            labelEn: 'Tunnel Machine',
            labelZh: '通道机',
            hidden: false,
            permission: ['menu_rfid_configuration_tunnelMachine', 'menu_rfid_configuration_tunnelMachine_view'],
            component: RfidTunnelMachine
          },
          {
            key: '/rfidconfiguration/warehouse',
            label: 'ADC Warehouse',
            labelEn: 'ADC Warehouse',
            labelZh: 'ADC 仓库',
            hidden: false,
            permission: ['menu_rfid_configuration_adcWarehouseConfig'],
            component: AdcWarehouse
          },
          {
            key: '/rfidconfiguration/specialType',
            label: 'Special Type',
            labelEn: 'Special Type',
            labelZh: '特殊产品类型',
            hidden: false,
            permission: ['menu_rfid_configuration_specialType', 'menu_rfid_configuration_specialType_view'],
            component: SpecialTypeConfigPage
          },
          {
            key: '/rfidconfiguration/specialSku',
            label: 'Special SKU',
            labelEn: 'Special SKU',
            labelZh: '特殊产品',
            hidden: false,
            permission: ['menu_rfid_configuration_specialSku', 'menu_rfid_configuration_specialSku_view'],
            component: SpecialSkuConfigPage
          },
          {
            key: '/rfidconfiguration/nddcStore',
            label: 'NDDC Store',
            labelEn: 'NDDC Store',
            labelZh: 'NDDC 门店',
            hidden: false,
            permission: ['menu_rfid_configuration_nddcStoreConfig', 'menu_rfid_configuration_nddcStoreConfig_view'],
            component: NddcStoreConfigPage
          }
        ]
      }
    ]
  },
  {
    key: '/GreyMarket',
    label: 'Grey Market',
    labelEn: 'Grey Market',
    labelZh: 'Grey Market',
    icon: <ProfileOutlined />,
    hidden: false,
    children: [
      {
        key: '/greymarketscan',
        label: 'Grey Market Scan',
        labelEn: 'Grey Market Scan',
        labelZh: 'Grey Market 扫描',
        icon: <UnorderedListOutlined />,
        hidden: false,
        permission: ['menu_greyMarke_greyMarketScan'],
        component: GreyMarketScan
      },
      {
        key: '/greymarketreport',
        label: 'Grey Market Report',
        labelEn: 'Grey Market Report',
        labelZh: 'Grey Market 报告',
        icon: <UnorderedListOutlined />,
        hidden: false,
        permission: ['menu_greyMarke_greyMarketReport'],
        component: GreyMarketReport
      }
    ]
  },
  {
    key: '/user',
    label: 'User',
    labelEn: 'User',
    labelZh: '用户',
    icon: <UsergroupAddOutlined />,
    hidden: false,
    children: [
      {
        key: '/user/rolemanagement',
        label: 'Role Management',
        labelEn: 'Role Management',
        labelZh: '角色管理',
        icon: <TeamOutlined />,
        // hidden: true,
        permission: ['menu_nfcAndRfid_roleManagement'],
        component: RoleManagement
      },
      {
        key: '/user/usermanagement',
        label: 'User Management',
        labelEn: 'User Management',
        labelZh: '用户管理',
        icon: <UserOutlined />,
        // hidden: true,
        permission: ['menu_nfcAndRfid_userManagement'],
        component: UserManagement
      }
    ]
  },
  {
    key: '/email',
    label: 'Email',
    labelEn: 'Email',
    labelZh: '邮件',
    icon: <MailOutlined />,
    hidden: false,
    children: [
      {
        key: '/email/emailManagement',
        label: 'Email Management',
        labelEn: 'Email Management',
        labelZh: '邮件管理',
        hidden: false,
        permission: ['menu_email_management_config', 'menu_email_management_view'],
        component: EmailManagement
      }
    ]
  }
]

// 外网访问路由
export const routerConfigEx = [
  {
    key: '/NFC',
    label: 'NFC',
    labelEn: 'NFC',
    labelZh: 'NFC',
    icon: <BarsOutlined />,
    hidden: false,
    children: [
      {
        key: '/tagnfc',
        label: 'NFC TAG',
        labelEn: 'NFC TAG',
        labelZh: 'NFC绑定',
        icon: <ScanOutlined />,
        hidden: false,
        children: [
          {
            key: '/tagnfc/fulltag',
            label: 'FULL TAG',
            labelEn: 'FULL TAG',
            labelZh: 'FULL绑定',
            hidden: false,
            permission: ['menu_nfc_tag_fullTag'],
            component: TagPage
          }
        ]
      },
      {
        key: '/writeOff',
        label: 'Write Off',
        labelEn: 'Write Off',
        labelZh: '销毁',
        icon: <ClearOutlined />,
        hidden: false,
        children: [
          {
            key: '/writeOff/writeOffUIDCollection',
            label: 'UID Collection',
            labelEn: 'UID Collection',
            labelZh: 'NFC 销毁UID采集',
            hidden: false,
            permission: ['menu_nfc_configuration_writeOffUIDCollection'],
            component: UIDCollection
          },
          {
            key: '/writeOff/writeOffUIDDisablementReport',
            label: 'UID Disablement Report',
            labelEn: 'UID Disablement Report',
            labelZh: 'NFC 销毁UID禁用报告',
            hidden: false,
            permission: [
              'menu_nfc_configuration_writeOffUIDDisablementReport_view',
              'menu_nfc_writeOff_writeOffUIDCollection_view'
            ],
            component: UIDDisablementReport
          },
          {
            key: '/writeOff/writeOffUIDCollectionUndoRecord',
            label: 'UID Collection Undo Record',
            labelEn: 'UID Collection Undo Record',
            labelZh: 'UID采集撤回记录',
            hidden: false,
            permission: ['menu_nfc_configuration_write_off_undo_record'],
            component: UIDCollectionUndoRecord
          },
          {
            key: '/configuration/writeOffNFCBatchNumber',
            label: 'Batch Number Configuration',
            labelEn: 'Batch Number Configuration',
            labelZh: 'NFC 销毁批次号配置',
            hidden: false,
            permission: [
              'menu_nfc_configuration_writeOffNFCBatchNumber',
              'menu_nfc_configuration_writeOffNFCBatchNumber_view'
            ],
            component: WriteOffNFCBatchNumber
          }
        ]
      }
    ]
  },
  {
    key: '/GreyMarket',
    label: 'Grey Market',
    labelEn: 'Grey Market',
    labelZh: 'Grey Market',
    icon: <ProfileOutlined />,
    hidden: false,
    children: [
      {
        key: '/greymarketscan',
        label: 'Grey Market Scan',
        labelEn: 'Grey Market Scan',
        labelZh: 'Grey Market 扫描',
        icon: <UnorderedListOutlined />,
        hidden: false,
        permission: ['menu_greyMarke_greyMarketScan'],
        component: GreyMarketScan
      },
      {
        key: '/greymarketreport',
        label: 'Grey Market Report',
        labelEn: 'Grey Market Report',
        labelZh: 'Grey Market 报告',
        icon: <UnorderedListOutlined />,
        hidden: false,
        permission: ['menu_greyMarke_greyMarketReport'],
        component: GreyMarketReport
      }
    ]
  },
  {
    key: '/RFID',
    label: 'RFID',
    labelEn: 'RFID',
    labelZh: 'RFID',
    icon: <ProfileOutlined />,
    hidden: false,
    children: [
      {
        key: '/rfidNSP',
        label: 'NSP',
        labelEn: 'NSP',
        labelZh: 'NSP',
        icon: <UnorderedListOutlined />,
        hidden: false,
        children: [
          {
            key: '/wsDefectiveReturn',
            label: 'WS Defective Return',
            labelEn: 'WS Defective Return',
            labelZh: 'WS Defective Return',
            hidden: false,
            children: [
              {
                key: '/rfidReport/rsoOverviewReport',
                label: 'RSO Overview Report',
                labelEn: 'RSO Overview Report',
                labelZh: 'RSO 总览报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_rsoOverviewReport'],
                component: RSOOverviewReport
              },
              {
                key: '/rfidReport/rsoDetailReport',
                label: 'RSO Detail Report',
                labelEn: 'RSO Detail Report',
                labelZh: 'RSO 明细报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_rsoDetailReport'],
                component: RSODetailReport
              },
              {
                key: '/skiprejectratereport',
                label: 'Skip & Reject Rate Report',
                labelEn: 'Skip & Reject Rate Report',
                labelZh: '跳过率/拒收率报表',
                hidden: false,
                permission: ['menu_rfid_dr_ws_skipRejectRateReport'],
                component: SkipRejectRateReport
              }
            ]
          }
        ]
      },
      {
        key: '/rfidReport',
        label: 'Report',
        labelEn: 'Report',
        labelZh: '报表',
        icon: <UnorderedListOutlined />,
        hidden: false,
        children: [
          {
            key: '/rfidReport/rfidTunnelScanAccuracyReport',
            label: 'Tunnel Scan Accuracy',
            labelEn: 'Tunnel Scan Accuracy',
            labelZh: '通道机扫描准确度',
            hidden: false,
            permission: ['menu_rfid_tunnelScanAccuracy'],
            component: RfidTunnelScanAccuracyReport
          },
          {
            key: '/rfidReport/operationAccuracyDetail',
            label: 'Operation Accuracy Detail',
            labelEn: 'Operation Accuracy Detail',
            labelZh: '运营准确度明细',
            hidden: false,
            permission: ['menu_rfid_operationAccuracyDetail'],
            component: OperationAccuracyDetail
          },
          {
            key: '/rfidReport/tunnelScanValidationResult',
            label: 'IB - Carton Validation Result Report',
            labelEn: 'IB - Carton Validation Result Report',
            labelZh: '入库 - 最新对比结果',
            hidden: false,
            permission: ['menu_rfid_tunnelScanValidationResult'],
            component: TunnelScanValidationResult
          },
          {
            key: '/rfidReport/obTunnelScanValidationResult',
            label: 'OB - Carton Validation Result Report',
            labelEn: 'OB - Carton Validation Result Report',
            labelZh: '出库 - 最新对比结果',
            hidden: false,
            permission: ['menu_rfid_obTunnelScanValidationResult'],
            component: ObTunnelScanValidationResult
          }
        ]
      },
      {
        key: '/reprintweb',
        label: 'RFID RePrint',
        labelEn: 'RFID RePrint',
        labelZh: 'RFID补打标签',
        icon: <PrinterOutlined />,
        hidden: false,
        children: [
          {
            key: '/reprintweb/reprint',
            label: 'RFID RePrint',
            labelEn: 'RFID RePrint',
            labelZh: 'RFID补打标签',
            hidden: false,
            permission: ['menu_rfid_reprint'],
            component: ReprintSCPage
          },
          {
            key: '/reprintweb/report',
            label: 'RFID RePrint Report',
            labelEn: 'RFID RePrint Report',
            labelZh: 'RFID补打标签报告',
            hidden: false,
            permission: ['menu_rfid_reprint_report'],
            component: ReprintReportPage
          }
        ]
      }
    ]
  }
]
